import { AgencyId, UserId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminAgentPreviewsQueryKey } from "../agency.keys";

export const useAdminCancelAgentInvitation = () => {
	const { _delete } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationKey: ["adminCancelAgentInvitation"],
		mutationFn: async ({ agencyId, agentId }: { agencyId: AgencyId; agentId: UserId }) => {
			await _delete(`/v2/admin/agencies/${agencyId}/agents/${agentId}/invite`, undefined, "none");
		},
		onSuccess: async () => {
			queryClient.invalidateQueries({ queryKey: adminAgentPreviewsQueryKey() });
		},
	});

	return {
		adminCancelAgentInvitation: mutation.mutate,
		adminCancelAgentInvitationIsLoading: mutation.isPending,
		adminCancelAgentInvitationError: mutation.error,
	};
};
